import React, { ChangeEvent, forwardRef } from "react";

import { AppMobileNumberProps } from "./AppMobileNumberInput.props";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
const MobileNumberInputFieldWithFlag = forwardRef(
  function MobileNumberInputFieldWithFlag(
    props: AppMobileNumberProps
  ): JSX.Element {
    const effectiveFont =
      props.fontFamilyForInput || "MBCorpoAScreen1Cond-Regular-Web";
    return (
      <div
        className={
          "w-full h-full box-border py-2 items-baseline flex flex-col justify-end " +
          props.className
        }
        style={{
          marginTop: "-5px",
        }}
      >
        <div style={{ marginBottom: "7px" }}>
          {props.showlabel && (
            <label
              className="MBCorpoAScreen1Cond-Regular-Web"
              style={{ color: "#FFFFFF" }}
            >
              {props.label}
            </label>
          )}
        </div>
        <PhoneInput
          specialLabel={""}
          containerClass={" w-full text-black"}
          country={"it"}
          inputClass={"w-full h-full text-black"}
          dropdownClass={"mx-4"}
          placeholder={props.placeholder}
          inputProps={{ required: props.required }}
          value={props.value}
          inputStyle={{
            height: props.containerheight,
            width: props.containerwidth,
            color: "black",
            backgroundColor: props.InputColor ? "#D9D9D9" : "#FFFFFF",
            fontFamily: effectiveFont,
          }}
          onChange={(phone) => {
            props.onChange(phone, {} as ChangeEvent<HTMLInputElement>);
          }}
        />
      </div>
    );
  }
);
export { MobileNumberInputFieldWithFlag };
